import React from 'react'
import PropTypes from 'prop-types'

import { YES_NO_OPTIONS } from 'utils/enums/questions'
import { FormRadioButtonGroup } from 'components/form/radioButtonGroup/FormRadioButtonGroup'
import { validateRequiredField } from 'utils/helpers/validators/byType/requiredField'

import styles from '../FormByState.module.scss'

export const UtFormConfig = {
  hadPaidEmploymentRequiredDirectlyCare: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasApplicantReliable: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasApplicantWorkSatisfactory: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasDisciplinaryAction: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wouldRehire: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
}

export const UTForm = ({ formData, handleFieldChange }) => (
  <div className={styles.form}>
    <FormRadioButtonGroup
      title="Has the applicant ever had paid employment that required them to directly care for, supervise, control, or have custody of a child (not including the hiring administrator's school)?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.hadPaidEmploymentRequiredDirectlyCare}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Was the applicant reliable?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasApplicantReliable}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Was the applicant's work satisfactory?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasApplicantWorkSatisfactory}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Was disciplinary action ever taken against the applicant for the physical or sexual abuse of a child?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasDisciplinaryAction}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Would you rehire this person?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wouldRehire}
      handleFieldChange={handleFieldChange}
    />
  </div>
)

UTForm.propTypes = {
  formData: PropTypes.object.isRequired,
  formMeta: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
